import axios from "../auth/FetchInterceptor";

export const getAllOwners = async (page = 1, limit = 10) => {
  const response = await axios.get(`/owner?page=${page}&limit=${limit}`);
  return response;
};

export const createOwner = async (data) => {
  const response = await axios.post("/owner", data);
  return response.data;
};

export const updateOwner = async (id, data) => {
  const response = await axios.put(`/owner/${id}`, data);
  return response.data;
};

export const updateOwnerStatus = async (id, status) => {
  const response = await axios.put(`/owner/${id}/status`, { status });
  return response.data;
};

export const deleteOwner = async (id) => {
  const response = await axios.delete(`/owner/${id}`);
  return response.data;
};
